// extracted by mini-css-extract-plugin
export default {"primarySection":"HomePage_primarySection__0v8yh","headingImg":"HomePage_headingImg__qGNmq"};